import { client } from "@/client/apollo";
import { AssessmentDocument, WorkDocument } from "@/generated/graphql";

/**
 * Fetch the Work's Sheet and Assessment settings from the server with a jitter.
 * We need to refetch those queries to ensure the Redux store is updated with
 * the latest data after a Sheet release.
 */
export async function refetchAssessment() {
  // Add a jitter not to overload the server
  await new Promise((r) => setTimeout(r, Math.random() * 3000));

  // If the new sheet released, we need to refetch the Assessment Query to
  // make sure we get the latest assessment settings and the Work Query to
  // ensure `onCompleted` is called and the Redux store is updated
  await client.refetchQueries({
    include: [AssessmentDocument, WorkDocument],
  });
}
